import { render, staticRenderFns } from "./settingsLot.vue?vue&type=template&id=6c24a015&"
import script from "./settingsLot.vue?vue&type=script&lang=js&"
export * from "./settingsLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports